import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { ArrowBack, GridViewOutlined } from "@mui/icons-material";
import { V2_COLORS } from "@/pages/InvoiceManagement/v2/constants/colors";
import type { VendorRfqDetail } from "../../types";
import { RFQ_TAB_PATH } from "../../constants/paths";
import { tradesOf } from "../../utils/response";
import { describeRfq, projectLine } from "../../utils/rfqCardCopy";
import RfqStatusBadge from "../RfqStatusBadge";

export const GST_NOTE = "All bids exclusive of GST · you will be asked to confirm before anything is sent";

interface RfqDetailHeaderProps {
  rfq: VendorRfqDetail;
  now: number;
  actions?: ReactNode;
}

export default function RfqDetailHeader({ rfq, now, actions }: RfqDetailHeaderProps) {
  const copy = describeRfq(rfq, now);

  return (
    <Box>
      <Link to={RFQ_TAB_PATH} style={{ color: V2_COLORS.textSecondary, textDecoration: "none", fontSize: "13px", display: "inline-flex", alignItems: "center", gap: 4 }}>
        <ArrowBack sx={{ fontSize: 16 }} />
        Back to RFQs
      </Link>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 1.5 }} flexWrap="wrap">
        <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: V2_COLORS.primaryBg, color: V2_COLORS.primary, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <GridViewOutlined sx={{ fontSize: 20 }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Typography component="h1" fontSize="22px" fontWeight={700} lineHeight="28px">
              {rfq.rfq_number}
            </Typography>
            <RfqStatusBadge status={rfq.status} />
          </Stack>
          <Typography fontSize="13px" sx={{ color: V2_COLORS.textSecondary, mt: 0.5 }}>
            {`${projectLine(rfq)} · ${tradesOf(rfq)}`}
          </Typography>
        </Box>
        {actions}
      </Stack>
      <Typography fontSize="12px" sx={{ color: V2_COLORS.textSecondary, mt: 1 }}>
        {GST_NOTE}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mt: 1 }} flexWrap="wrap">
        <Typography fontSize="13px" fontWeight={500}>
          {copy.headline}
        </Typography>
        {copy.countdown && (
          <Chip
            size="small"
            label={copy.countdown}
            sx={{
              fontWeight: 600,
              color: copy.windowOpen ? V2_COLORS.warning : V2_COLORS.textSecondary,
              backgroundColor: copy.windowOpen ? V2_COLORS.warningBg : V2_COLORS.bgMuted,
            }}
          />
        )}
      </Stack>
    </Box>
  );
}
